var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example"},[_c('h1',[_vm._v("Example Page")]),_c('p',[_vm._v("This is our TodoList App v 1.0")])])}]

export { render, staticRenderFns }